import { RouteComponentProps } from 'react-router-dom';
import qs from 'query-string';
import { AppDispatch } from 'src/store';
import { IQueryParams } from 'src/types';
import { convertFilterToArray } from 'src/utils/convertFilter';
import { removeEmpty } from 'src/utils/removeEmpty';
import { createAction } from '@reduxjs/toolkit';

import {
  createPayoutAvailableMethodRequest,
  deletePayoutAvailableMethodsRequest,
  fetchPayoutAvailableMethodRequest,
  fetchPayoutAvailableMethodsRequest,
  updatePayoutAvailableMethodsRequest,
} from './requestHandlers';
import { IPayoutAvailableMethod, IPayoutAvailableMethodData } from './types';

const defaultParams = {
  page: '0',
  size: '25',
  sort: 'id,asc',
};

export const loadPayoutAvailableMethodsStart = createAction('payout_available_methods/methods/load/start');

export const loadPayoutAvailableMethodsSuccess = createAction<IPayoutAvailableMethodData>('payout_available_methods/methods/load/success');

export const loadPayoutAvailableMethodStart = createAction('payout_available_methods/method/load/start');

export const loadPayoutAvailableMethodSuccess = createAction<Partial<IPayoutAvailableMethod>>(
  'payout_available_methods/method/load/success',
);

export const resetPayoutAvailableMethod = createAction('payout_available_methods/method/reset');

export const loadPayoutAvailableMethods = (
  history: RouteComponentProps['history'],
  params: IQueryParams = {},
  isInitialLoading?: boolean,
  type?: string,
) => {
  return async (dispatch: AppDispatch): Promise<void> => {
    if (isInitialLoading) {
      dispatch(loadPayoutAvailableMethodsStart());
    }
    const initialParams = qs.parse(history.location.search);
    const mergedParams = type === 'reset' ? defaultParams : removeEmpty({ ...defaultParams, ...initialParams, ...params });

    mergedParams.siteIds = convertFilterToArray(mergedParams.siteIds);
    mergedParams.payoutSystemGroupIds = convertFilterToArray(mergedParams.payoutSystemGroupIds);
    mergedParams.paymentSystemGroupIds = convertFilterToArray(mergedParams.paymentSystemGroupIds);

    const data = await fetchPayoutAvailableMethodsRequest(mergedParams);
    if (data) {
      dispatch(loadPayoutAvailableMethodsSuccess(data));
      history.replace({
        search: qs.stringify(mergedParams, { skipNull: true }),
      });
    }
  };
};

export const loadPayoutAvailableMethod = (id: string, isInitialLoading?: boolean) => {
  return async (dispatch: AppDispatch): Promise<void> => {
    if (isInitialLoading) {
      dispatch(loadPayoutAvailableMethodStart());
    }
    const data = await fetchPayoutAvailableMethodRequest(id);
    if (data) {
      dispatch(loadPayoutAvailableMethodSuccess(data));
    }
  };
};

export const createPayoutAvailableMethod = (data: Partial<IPayoutAvailableMethod>): Promise<Partial<IPayoutAvailableMethod>> =>
  createPayoutAvailableMethodRequest(data);
export const updatePayoutAvailableMethod = (data: Partial<IPayoutAvailableMethod>): Promise<Partial<IPayoutAvailableMethod>> =>
  updatePayoutAvailableMethodsRequest(data);
export const deletePayoutAvailableMethod = (id: number): Promise<void> => deletePayoutAvailableMethodsRequest(id);
